import Vue from 'vue';
import App from './App.vue';
import { router } from './router';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === 'development';

new Vue({
  router,
  data:function(){
    return{
      is_mobile:false,      // 设置全局变量, 用于判断PC端还是移动端。
    }
  },
  el: '#app',
  render: h => h(App),
})
